//import {useListView} from '../../core/ListViewProvider'
import {useIntl} from 'react-intl'

const LicensesListToolbar = () => {
  const intl = useIntl()
  // const {setItemIdForUpdate} = useListView()
  // const openAddUserModal = () => {
  //   setItemIdForUpdate(null)
  // }

  return (
    <div className='d-flex justify-content-start mb-3' data-kt-user-table-toolbar='base'>
      {/* begin::Export */}
      <button type='button' className='btn btn-sm btn-light-primary me-3'>
        <i className='bi bi-plus fs-3'></i>
        {intl.formatMessage({id: 'COMMON.BUTTON.EXPORT'})}
      </button>
      {/* end::Export */}

      {/* begin::Add user */}

      {/* end::Add user */}
    </div>
  )
}

export {LicensesListToolbar}
